export default __webpack_public_path__ + "static/media/Login.fd4c5863.png";